/**
 * @generated SignedSource<<f7fbc559eec5624709ee73b4742b3b2c>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useCompanyHubPremiumGateCompanyHubPremiumGateQuery$variables = Record<PropertyKey, never>;
export type useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data = {
  readonly entitlements: {
    readonly companyHub: {
      readonly isEntitled: boolean;
    };
  } | null | undefined;
};
export type useCompanyHubPremiumGateCompanyHubPremiumGateQuery = {
  response: useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data;
  variables: useCompanyHubPremiumGateCompanyHubPremiumGateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "CompanyHubFeature",
        "kind": "LinkedField",
        "name": "companyHub",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
    "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
    "metadata": {},
    "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
    "operationKind": "query",
    "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
  }
};
})();

(node as any).hash = "a5508e7e7123c5675909c4f9214a5be2";

export default node;
